import { EventService } from "@/services/event.service"
import { eventTypes, courseTypeList } from "@/assets/js/utils";
import { mapGetters } from "vuex";
import moment from "moment";
export const eventMixin = {
    data() {
        return {
            rawEventData: [],
            events: [],
            selectedMonthEvents:[],
            loading: true,
            errored: false,
            types: eventTypes(),
            currentYear: -1,
            currentMonth: -1,
             months: [ "January", "February", "March", "April", "May", "June", 
           "July", "August", "September", "October", "November", "December" ]
        };
    },
    created() {
        this.loading = true;
        this.fetchData();
    },
    mounted() {
        this.currentMonth = new Date().getMonth() + 1;
        this.currentYear = new Date().getFullYear();
    },
    computed: {
        ...mapGetters({

        }),
        dashboardEventList() {
            return this.monthEventList.splice(0, 5)
        }
    },
    methods: {
        fetchData() {

            EventService.getAll()
                .then((response) => this.buildList(response.data.data))
                .catch((err) => {
                    console.log("events " + err);
                    this.errored = true;
                })
                .finally(() => {
                    this.loading = false
                    this.parseMonthEventList(this.currentMonth)
                });
        },
        buildList(data) {
            this.loading = false
            const vm = this;
    
            let yearData = data
             .flatMap(function(obj) {
               return obj.data;
              })

            vm.rawEventData = yearData;


            let monthData = yearData
            .flatMap(function(obj) {
                return obj.month_data;
            });

            monthData.forEach(function (obj) {
                let type = vm.getProgramType(obj);
                let schoolOwned = vm.isEventShoolOwned(obj)

                let eventObj = {
                    key: obj.identifier,
                    customData: {
                        title: obj.title,
                        class: type != undefined ? type.class : "bg-red-200",
                        schoolOwned: schoolOwned,
                        type: obj.program_type
                    },
                    dates: [
                        {
                            // start: new Date(this.thisMonthYear, this.thisMonth, 2),
                            // end: new Date(this.thisMonthYear, this.thisMonth, 4),
                            start: new Date(obj.start_date),
                            end: new Date(obj.end_date),
                        }
                    ],
                }
            
                vm.events.push(eventObj)

            });
        },
        parseMonthEventList(monthNumber) {
            this.selectedMonthEvents = []
          
            let vm = this;
            let monthlyEvents = this.rawEventData 
                .filter(function(obj) {
                    return obj.month.toLowerCase() === vm.months[monthNumber -1].toLowerCase();
                })
                .flatMap(function(obj) {
                    return obj.month_data;
                });


            this.selectedMonthEvents = _.orderBy(monthlyEvents, ["start_date", "program_type", "title"]);
        },
        formatDate(date, format) {
            return moment(date).format(format);
        },
        parseDate(date) {
            return moment(date).format("DD/MM/YYYY, h:mm a");
        },
        getProgramType(event) {
            return this.types.find((t) => t.value === event.program_type);
        },
        getProgramTypeClass(event) {
            let type = this.getProgramType(event);
            return type != undefined ? type.class : "bg-red-200";
        },
        isEventShoolOwned(event) {
            var type = courseTypeList(event.type_id);
            return type.value != "organisation";
        }



    }
};
